import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { emptyVideo, Video } from "../../../../interfaces/video";
import { useEffect, useState } from "react";
import { deleteVideo, getVideoSingle } from "../../../../services/video";
import { Trans } from "react-i18next";
import { LoadingSpinner } from "../../../general/loading-spinner";

interface AdminVideoDeleteProps {
    id: number;
    onDelete: CallableFunction;
    onClose: CallableFunction;
}

export function AdminVideoDelete(props: AdminVideoDeleteProps) {
    const [video, setVideo] = useState<Video>(emptyVideo);

    const handleDelete = () => {
        deleteVideo(props.id)
            .then(response => {
                if (response.data == 0) {
                    alert(t("Video cannot be deleted. Try again later."));
                } else {
                    props.onDelete(props.id);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleClose = () => {
        props.onClose();
    }

    useEffect(() => {
        getVideoSingle(props.id)
            .then(response => {
                setVideo(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    return (
        <Modal className="admin-video-delete-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("delete_video") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { video.id == 0 && 
                    <LoadingSpinner />
                }
                { video.id != 0 &&
                    <Form onSubmit={ handleDelete }>
                        <div className="fields">
                            <Trans i18nKey="delete_video_message"
                                values={{
                                    video_name: video.name
                                   }} />
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Delete") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}